export default "/storefront/client/images/placeholder.jpg";